<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50 md-large-size-100">
      <SearchTable
        ref="materialsTable"
        :header="{
          title: 'Magacin',
          icon: 'inventory_2',
          class: 'md-card-header-brand',
        }"
        :queriedData="materials"
        :metaData="materialsMetaData"
        :getItems="getMaterialCount"
        :openItem="openMaterial"
        :params="materialParams"
        :sortBy="'type'"
      >
        <div slot="header" class="md-layout-item reset-inventory-container">
          <ResetInventoryButton :onReset="getMaterialCount" />
        </div>
      </SearchTable>
    </div>
    <div class="md-layout-item md-size-30 md-large-size-100">
      <SearchTable
        v-if="openedMaterial"
        ref="inputsTable"
        :header="{
          title: openedMaterialTitle,
          icon: 'inventory_2',
          class: 'md-card-header-brand',
        }"
        :queriedData="inputs"
        :metaData="inputsMetaData"
        :getItems="getManualMaterialInputs"
        :newItem="addMaterial"
        :params="inputsParams"
        :forEachSelected="[
          {
            icon: 'delete',
            label: 'Briši',
            class: 'md-danger',
            function: deleteExpenses,
          },
        ]"
        :sortBy="'created'"
      />
    </div>
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTable.vue';
import ResetInventoryButton from '@/components/ResetInventoryButton.vue';
import services from '@/api/services';
import api from '@/api/api.js';
import Swal from 'sweetalert2';
import { cases } from '../utils/helpers';
export default {
  components: {
    SearchTable,
    ResetInventoryButton,
  },
  computed: {
    openedMaterialTitle() {
      if (!this.openedMaterial) return undefined;
      if (this.openedMaterial.name === this.openedMaterial.type)
        return this.openedMaterial.name;

      return `${this.openedMaterial.type} ${this.openedMaterial.name}`;
    },
  },
  data() {
    return {
      materialParams: {
        name: '',
        type: '',
        amount: [null, null],
        unit: '',
      },
      inputsParams: {
        created: [null, null],
        amount: [null, null],
        comment: '',
      },
      materials: [],
      materialsMetaData: null,
      inputs: [],
      inputsMetaData: null,
      openedMaterial: null,
    };
  },
  methods: {
    getMaterialCount(printTable = false) {
      const offset = this.materialsMetaData
        ? this.$refs.materialsTable.from
        : 0;
      const limit = this.materialsMetaData
        ? this.$refs.materialsTable.pagination.perPage
        : 75;
      const sortBy = this.materialsMetaData
        ? this.$refs.materialsTable.currentSort
        : null;
      const sortOrder = this.materialsMetaData
        ? this.$refs.materialsTable.currentSortOrder
        : null;
      api
        .get(services.itemCount.getMaterialCount, {
          getMaterialCount: true,
          params: this.materialParams,
          offset,
          limit,
          sortBy,
          sortOrder,
          printTable,
        })
        .then((data) => {
          this.materials = data.data;
          this.materialsMetaData = data.metaData;
          if (this.openedMaterial) this.getManualMaterialInputs();
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    getManualMaterialInputs(printTable = false) {
      const offset = this.inputsMetaData ? this.$refs.inputsTable.from : 0;
      const limit = this.inputsMetaData
        ? this.$refs.inputsTable.pagination.perPage
        : 75;
      const sortBy = this.inputsMetaData
        ? this.$refs.inputsTable.currentSort
        : null;
      const sortOrder = this.inputsMetaData
        ? this.$refs.inputsTable.currentSortOrder
        : null;
      const { materialId, materialTypeId } = this.openedMaterial;
      api
        .get(services.itemCount.getManualMaterialInputs, {
          materialId,
          materialTypeId,
          params: this.inputsParams,
          offset,
          limit,
          sortBy,
          sortOrder,
          printTable,
        })
        .then((data) => {
          this.inputs = data.data;
          this.inputsMetaData = data.metaData;
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    addMaterial() {
      const material = this.openedMaterial;
      Swal.fire({
        title: 'Unos materijala',
        html: `Upiši manuelni unos materijala ${material.name}
                      <div class="material-input-params">
                          <input
                              type="number"
                              id="materialInputAmount"
                              step="1"
                              min="1"
                              placeholder="${material.unit}">
                          </input>
                          <textarea 
                            id="materialInputComment" 
                            placeholder="Napomena" 
                            rows="4" 
                            columns="20"
                            ></textarea>
                          <div>
                            <label for="materialInputIn">Ulaz</label>
                            <input
                              type="radio"
                              id="materialInputIn"
                              name="materialInputDirection"
                              value="in"
                              checked
                              />

                            <label for="materialInputOut">Izlaz</label>
                            <input
                              type="radio"
                              id="materialInputOut"
                              name="materialInputDirection"
                              value="out"
                              />
                          </div>
                      </div>`,
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success',
        cancelButtonClass: 'md-button md-danger',
        confirmButtonText: 'Dodaj!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then(({ value }) => {
        if (!value) return;
        const direction = document.querySelector(
          'input[name="materialInputDirection"]:checked',
        ).value;
        const amount =
          Math.abs(
            parseInt(document.getElementById('materialInputAmount').value),
          ) * (direction === 'in' ? 1 : -1);
        const comment = document.getElementById('materialInputComment').value;
        const { materialId, materialTypeId } = material;

        api
          .post(services.itemCount.setManualMaterialInput, {
            amount,
            materialId,
            materialTypeId,
            comment,
          })
          .then(() => this.getMaterialCount())
          .catch(this.alertError);
      });
    },
    deleteExpenses(items) {
      const ids = items.map((el) => el.id);
      return Swal.fire({
        title: 'Obriši zapise',
        text: `Da li ste sigurni da želite da obrišete ${ids.length} ${cases(
          ids.length,
          'zapis',
          'zapisa',
          'zapisa',
        )}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-danger btn-fill',
        cancelButtonClass: 'md-button btn-fill',
        confirmButtonText: 'Obriši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then(({ value }) => {
        if (!value) return;
        api
          .post(services.expenses.deleteExpenses, {
            deleteExpenses: true,
            ids,
          })
          .then(() => {
            this.getMaterialCount();
            this.$refs.inputsTable.removeChecked();
          })
          .catch((error) => {
            this.alertError(error);
          });
      });
    },
    openMaterial(material) {
      this.openedMaterial = material;
      this.getManualMaterialInputs();
    },
  },
  mounted() {
    this.getMaterialCount();
  },
};
</script>

<style>
.reset-inventory-container {
  text-align: end;
  align-self: flex-end;
}

.material-input-params {
  padding: 5px;
  display: inline-flex;
  flex-direction: column;
  gap: 10px;
}

.material-input-params input,
.material-input-params textarea {
  font-size: 1.1rem;
}

.material-input-params textarea {
  resize: vertical;
  min-height: 3rem;
  max-height: 20rem;
}
</style>
